
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trackorder",
      function () {
        return require("private-next-pages/trackorder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trackorder"])
      });
    }
  